// extracted by mini-css-extract-plugin
export default {"wrapper":"LVTWWx248dUscKM3527Vu","card":"_3Lda3wywYrWYtE8QDPU_XX","logoContainer":"DcOIf75win7my6rlcujVU","logo":"_2Q8-BjToHfCNKaGQAXOEIN"};